export default __webpack_public_path__ + "static/media/cow-five.da982d7f.jpeg";